var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2IconMore20N({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54189 8.00005C7.54189 8.66279 8.07915 9.20005 8.74189 9.20005C9.40464 9.20005 9.94189 8.66279 9.94189 8.00005C9.94189 7.33731 9.40464 6.80005 8.74189 6.80005C8.07915 6.80005 7.54189 7.33731 7.54189 8.00005Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95874 8.00005C9.95874 7.3373 9.42148 6.80005 8.75874 6.80005C8.096 6.80005 7.55874 7.3373 7.55874 8.00005C7.55874 8.66279 8.096 9.20005 8.75874 9.20005C9.42148 9.20005 9.95874 8.66279 9.95874 8.00005Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54189 3.2C7.54189 3.86274 8.07915 4.4 8.74189 4.4C9.40464 4.4 9.94189 3.86274 9.94189 3.2C9.94189 2.53726 9.40464 2 8.74189 2C8.07915 2 7.54189 2.53726 7.54189 3.2Z",
    fill: "#292929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55874 3.2C7.55874 3.86274 8.096 4.4 8.75874 4.4C9.42148 4.4 9.95874 3.86274 9.95874 3.2C9.95874 2.53726 9.42148 2 8.75874 2C8.096 2 7.55874 2.53726 7.55874 3.2Z",
    fill: "#292929"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54189 12.8C7.54189 13.4627 8.07915 14 8.74189 14C9.40464 14 9.94189 13.4627 9.94189 12.8C9.94189 12.1372 9.40464 11.6 8.74189 11.6C8.07915 11.6 7.54189 12.1372 7.54189 12.8Z",
    fill: "#292929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55874 12.8C7.55874 13.4627 8.096 14 8.75874 14C9.42148 14 9.95874 13.4627 9.95874 12.8C9.95874 12.1372 9.42148 11.6 8.75874 11.6C8.096 11.6 7.55874 12.1372 7.55874 12.8Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2IconMore20N);
export default __webpack_public_path__ + "static/media/S2_Icon_More_20_N.cd06c077c36370d598940afaa3388a52.svg";
export { ForwardRef as ReactComponent };